import { Capacitor } from "@capacitor/core";
import { api } from "./api";

export const PLAY_SUB_ID = "arcana_sub_monthly";
export const PLAY_CREDITS_ID = "acquisto_singolo_3";
export const PLAY_BASE_PLAN = "monthly";
// Pagina ufficiale di Arcana su Google Play (applicationId it.arcana.app)
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=it.arcana.app";

export const isNativeAndroid = () => Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android";

// Pagamenti SOLO sull'app Android (Google Play Billing). Sul sito gli acquisti sono disattivati:
// il web può consumare consultazioni e crediti già disponibili, ma non acquistarne di nuovi.
async function purchase(productId, productType, planIdentifier) {
  const { NativePurchases, PURCHASE_TYPE } = await import("@capgo/native-purchases");
  const { isBillingSupported } = await NativePurchases.isBillingSupported();
  if (!isBillingSupported) throw new Error("Google Play Billing non è disponibile su questo dispositivo.");
  const opts = { productIdentifier: productId, productType, quantity: 1 };
  if (planIdentifier) opts.planIdentifier = planIdentifier;
  const result = await NativePurchases.purchaseProduct(opts);
  if (!result.purchaseToken) throw new Error("Acquisto non completato: token mancante.");
  await api.post("/billing/verify", { product_id: productId, purchase_token: result.purchaseToken });
  const ent = await api.get("/entitlements");
  return { ...ent.data, simulated: false };
}

export async function buySubscription() {
  if (!isNativeAndroid()) {
    throw new Error("Acquisti e abbonamenti sono disponibili solo dall'app Android di Arcana.");
  }
  const { PURCHASE_TYPE } = await import("@capgo/native-purchases");
  return purchase(PLAY_SUB_ID, PURCHASE_TYPE.SUBS, PLAY_BASE_PLAN);
}

export async function buyCredits() {
  if (!isNativeAndroid()) {
    throw new Error("Acquisti e abbonamenti sono disponibili solo dall'app Android di Arcana.");
  }
  const { PURCHASE_TYPE } = await import("@capgo/native-purchases");
  return purchase(PLAY_CREDITS_ID, PURCHASE_TYPE.INAPP, null);
}

// All'avvio dell'app: riverifica gli acquisti presenti sul dispositivo.
// Il backend è idempotente (nessun doppio accredito) e completa il consume dei token rimasti in sospeso.
export async function restorePendingPurchases() {
  if (!isNativeAndroid()) return;
  try {
    const { NativePurchases } = await import("@capgo/native-purchases");
    const { isBillingSupported } = await NativePurchases.isBillingSupported();
    if (!isBillingSupported) return;
    const { purchases } = await NativePurchases.getPurchases();
    for (const p of purchases || []) {
      const token = p.purchaseToken;
      const pid = p.productIdentifier;
      if (!token || ![PLAY_SUB_ID, PLAY_CREDITS_ID].includes(pid)) continue;
      await api.post("/billing/verify", { product_id: pid, purchase_token: token }).catch(() => {});
    }
  } catch (e) {
    // best-effort: mai bloccare l'avvio dell'app per il ripristino acquisti
  }
}
